import styled from 'vue-styled-components'
import hljs from 'highlight.js'
import markdownToTxt from 'markdown-to-txt'
import { loadImagesSrc, previewRender } from '../utils'
import { mapActions } from 'vuex'

window.hljs = hljs
window.loadImagesSrc = loadImagesSrc

const MarkdownViewerWrapper = styled.div`
.CodeMirror-scroll, .CodeMirror-vscrollbar, .CodeMirror-hscrollbar {
  display: none !important;
}

.CodeMirror {
  border: none !important;
  border-radius: 0 !important;
  height: 100% !important;
  min-height: 100% !important;
  background-color: transparent !important;
}

.attachment-image {
  visibility: hidden;
}
`

export default {
  name: 'MarkdownViewer',
  props: {
    content: String,
    plain: Boolean,
    color: String
  },
  data () {
    return {
      viewer: null,
      innerValue: null,
      config: {
        autoDownloadFontAwesome: false,
        spellChecker: false,
        status: false,
        forceSync: true,
        toolbar: false,
        toolbarTips: false,
        previewRender
      }
    }
  },
  components: {
    VueSimplemde: () => import(/* webpackChunkName: "vue-simplemde" */'vue-simplemde'),
    MarkdownViewerWrapper
  },
  async created () {
    this.innerValue = this.content
    await this.checkImg(this.innerValue)
  },

  computed: {
    plainText () {
      return this.plain && this.innerValue && markdownToTxt(this.innerValue)
    }
  },

  updated () {
    if (this.viewer && this.viewer.isPreviewActive()) {
      this.viewer.togglePreview()
      this.viewer.togglePreview()
      this.viewer.codemirror.refresh()
    }
  },

  watch: {
    content (val) {
      this.innerValue = val
    }
  },

  methods: {
    ...mapActions({
      'notifyError': 'notificationStore/notifyError',
      'notifyUserConfirm': 'notificationStore/notifyUserConfirm'
    }),
    async checkImg (value) {
      try {
        if (value) {
          const regex = /!\[.*?\]\((.*?)\)/
          const matches = value.match(regex)
          const imageName = matches ? matches[1] : null
          if (imageName) {
            const imageSource = await loadImagesSrc(imageName)
            this.innerValue = value.replace(regex, `![${imageName}](${imageSource})`)
          }
        }
      } catch (error) {
        this.notifyError(error)
      }
    },
    init () {
      this.viewer = this.$refs.markdownViewer.simplemde || {}
      this.viewer.togglePreview()
      this.viewer.codemirror.refresh()
    }
  },

  directives: {
    color: {
      bind (el, binding) {
        if (binding.value) {
          const classes = binding.value.split(' ')
          el.classList.add(...classes)
        }
      }
    }
  }

}
